/* specs/09-bulk-orders.md */

(function () {
  const form = document.getElementById('BulkOrderForm');
  if (!form) {
    // Still handle the hero's smooth-scroll even without the form section.
    bindScrollTo();
    return;
  }

  bindScrollTo();
  bindChipGroups();
  bindDeliverToggle();
  preselectOccasionFromQuery();
  bindSubmit();

  function bindScrollTo() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-scroll-to]');
      if (!trigger) return;
      const target = document.querySelector(trigger.dataset.scrollTo);
      if (!target) return;
      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  function bindChipGroups() {
    // Single-select groups: every .chip inside the same .bulk-form__row toggles
    // its siblings off, except the personalisation row (data-multiselect).
    form.querySelectorAll('.bulk-form__row .bulk-form__chips').forEach((group) => {
      group.addEventListener('click', (event) => {
        const chip = event.target.closest('.chip');
        if (!chip) return;
        const isMulti = chip.hasAttribute('data-multiselect');

        if (isMulti) {
          const selected = chip.classList.toggle('is-selected');
          chip.setAttribute('aria-pressed', String(selected));
        } else {
          group.querySelectorAll('.chip').forEach((c) => {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('is-selected');
          chip.setAttribute('aria-pressed', 'true');
        }

        if (group.hasAttribute('data-deliver-group')) {
          toggleRecipientUpload(chip.dataset.deliverMode);
        }
      });
    });
  }

  function toggleRecipientUpload(mode) {
    const upload = form.querySelector('[data-recipient-upload]');
    if (upload) upload.hidden = mode !== 'many';
  }

  function bindDeliverToggle() {
    const selected = form.querySelector('[data-deliver-group] .chip.is-selected');
    toggleRecipientUpload(selected ? selected.dataset.deliverMode : 'one');
  }

  function preselectOccasionFromQuery() {
    const params = new URLSearchParams(window.location.search);
    const occasion = params.get('occasion');
    if (!occasion) return;
    const group = form.querySelector('[data-occasion-group]');
    if (!group) return;
    const match = group.querySelector(`.chip[data-occasion-key="${occasion}"]`);
    if (!match) return;
    group.querySelectorAll('.chip').forEach((c) => {
      c.classList.remove('is-selected');
      c.setAttribute('aria-pressed', 'false');
    });
    match.classList.add('is-selected');
    match.setAttribute('aria-pressed', 'true');
  }

  function selectedChipText(selector) {
    return Array.from(form.querySelectorAll(selector))
      .map((chip) => chip.textContent.trim())
      .join(', ');
  }

  function buildSummary() {
    const lines = [
      `Occasion: ${selectedChipText('[data-occasion-group] .chip.is-selected') || '—'}`,
      `How many boxes: ${selectedChipText('[data-field="quantity"] .chip.is-selected') || '—'}`,
      `Budget per box: ${selectedChipText('[data-field="budget"] .chip.is-selected') || '—'}`,
      `Needed by: ${form.querySelector('#BulkNeededBy')?.value || '—'}`,
      `Deliver to: ${selectedChipText('[data-deliver-group] .chip.is-selected') || '—'}`,
      `Personalisation: ${selectedChipText('[data-field="personalisation"] .chip.is-selected') || 'None'}`,
      `Company: ${form.querySelector('#BulkCompany')?.value || '—'}`,
      `Remind before every festive season: ${form.querySelector('[name="contact[remind]"]')?.checked ? 'Yes' : 'No'}`,
      `Notes: ${form.querySelector('#BulkNotes')?.value || '—'}`,
    ];
    return lines.join('\n');
  }

  function bindSubmit() {
    form.addEventListener('submit', (event) => {
      const summaryField = form.querySelector('[data-bulk-form-summary]');
      if (summaryField) summaryField.value = buildSummary();

      // The native Shopify contact form posts and reloads the page by default.
      // We intercept it here so the brief is tagged/stored the same way, but the
      // confirmation panel matches the prototype instead of a full page reload.
      // Swap this handler for the chosen Shopify Forms app's own submit flow —
      // the fields and summary text above are ready to hand off to it.
      event.preventDefault();
      const formData = new FormData(form);
      const summaryText = summaryField ? summaryField.value : '';

      fetch(form.action, { method: 'POST', body: formData })
        .then(() => showConfirmation(summaryText))
        .catch(() => showConfirmation(summaryText));
    });
  }

  function showConfirmation(summaryText) {
    form.hidden = true;
    const confirmation = document.querySelector('[data-bulk-confirmation]');
    if (!confirmation) return;
    confirmation.hidden = false;
    const summaryEl = confirmation.querySelector('[data-bulk-confirmation-summary]');
    if (summaryEl) summaryEl.textContent = summaryText.replace(/\n/g, ' · ');
  }
})();
